module.exports = __webpack_public_path__ + "static/media/canal2.c7acaae0.jpg";